import React from "react";
import * as ReactBootstrap from "react-bootstrap";
import { dollarUS } from "../../utilities/formatters";

const StatFormatter = (data) => {
  const classList = data < 0 ? "Negative" : "Positive";
  return <div className={`Status ${classList}`}>{dollarUS(data)}</div>;
};

const ShortTradesTable = ({ data }) => {
  const renderShortTrades = (instrument, index) => {
    const data = instrument[1];
    return (
      <tr key={index}>
        <td>{data.short_trade}</td>
        <td>{StatFormatter(data.short_result)}</td>
      </tr>
    );
  };

  return (
    <div className="CommonTable InstrumentsTable">
      <div
        className="Positive mbb-5"
        style={{ fontWeight: 700, textAlign: "left" }}
      >
        Short Trades
      </div>
      <ReactBootstrap.Table>
        <thead>
          <tr>
            <th>No. trades</th>
            <th>Results</th>
          </tr>
        </thead>
        <tbody>{data && data.map(renderShortTrades)}</tbody>
      </ReactBootstrap.Table>
    </div>
  );
};

export default ShortTradesTable;
